import { useNavigate } from "react-router-dom";
import { Award, Clock, TextParagraph } from "react-bootstrap-icons";
import { useContext, useState } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import { config } from "../../constants/config";
import UserContext from "../../contexts/UserContext";



export default function AddLicence() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [durre, setDuree] = useState('');
    const [type, setType] = useState('');
    const [client, setClient] = useState('');
    const [typelicence, setTypeLicence] = useState([]);
    const [clientlist, setClientList] = useState([]);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getTypesLicence = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns?nomtab=typelicence`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element.lib, value: element.code });
                        });

                        setTypeLicence(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            console.log("error get tabonnement list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    const getClientList = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/customers`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({ label: element?.prenom !== null ? element.nom + " (" + element.prenom + ")" : element.nom, value: element.code });
                        });

                        setClientList(clientarraydata);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // console.log("get departement list", "error")
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("get staut erreur", "error");
            }

        }).catch((err) => {
            // console.log("error get client list", err);
            // setError(true);
            // setLoading(false);
        });
    }

    // comportements
    useEffect(() => {
        getTypesLicence();
        getClientList();
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault();

        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();

        urlencoded.append("lib", name);
        urlencoded.append("typelicence", type["value"]);
        if (durre) urlencoded.append("duree", durre > 1 ? durre + " months" : durre + " month");
        urlencoded.append("codeclient", client["value"]);
        urlencoded.append("descr", desc);
        urlencoded.append("defaut", false);
        urlencoded.append("edit", true);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/licenses`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setFetching(false);
                            showErrorMessage(data?.body?.data?.msg)
                        }
                    } else {
                        setFetching(false);
                        navigate(-1);
                    }

                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("resonse ", response);
                // setError(true);
                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                setFetching(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            // setError(true);
            showErrorMessage("Service indisponible! Reessayez plutard.");
            setFetching(false);
        });
    }


    // affichages
    return (
        <div className="container-fluid">
            <h1 className="h4 mb-4 font-weight-bold text_primary">Licence</h1>
            <div className="row">
                <div className="col-md-12">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quitter" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                <i className="fa fa-reply"></i> <span>Retour</span>
                            </button>
                            <h6 className="m-0 ">Informations de la licence</h6>
                        </div>
                        <div className="card-body">
                            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                                <div className="row">
                                    {/* <div className="col-md-4 mb-3">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-2">
                                                                <label htmlFor="logo" className="form-label">Logo du client</label>
                                                                <input className="form-control" type="file" id="logo" onChange={handleLogoChange} />
                                                            </div>
                                                            <div className="col-md-12 mb-1">
                                                                <img alt="" src={logoprev} className="rounded" style={{width: "100%"}} />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                    <div className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="client" className="mb-1">Client</label>
                                                <Select
                                                    id="client"
                                                    name="client"
                                                    options={clientlist}
                                                    value={client}
                                                    onChange={(selected) => { setClient(selected); }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="typelicence" className="mb-1">Type de licence</label>
                                                <Select
                                                    id="typelicence"
                                                    name="typelicence"
                                                    options={typelicence}
                                                    value={type}
                                                    onChange={(selected) => { setType(selected); }}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="liblicene" className="mb-1">Libelle</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="liblicene">
                                                        <Award />
                                                    </span>
                                                    <input type="text"
                                                        className="form-control"
                                                        placeholder="Entrez le libelle"
                                                        aria-label="Libelle Licence"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="durrelicence" className="mb-1">Durée de licence (en mois) </label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="durrelicence">
                                                        <Clock />
                                                    </span>
                                                    <input type="number"
                                                        className="form-control"
                                                        placeholder="Entrez la durée de la licence"
                                                        value={durre}
                                                        onChange={(e) => setDuree(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label htmlFor="desc" className="mb-1">Description</label>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="desc">
                                                        <TextParagraph />
                                                    </span>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Entrez la description du client"
                                                        value={desc}
                                                        onChange={(e) => setDesc(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <button type="submit"
                                            title="Valider l'ajout"
                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                            disabled={name && desc && client["value"] && type["value"] ? false : true}
                                        >
                                            <i className="fa fa-check mr-2"></i>
                                            <span>Valider</span> {fetching && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}